export default __webpack_public_path__ + "static/media/site.40651285.svg";